import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActivityItemDetailsForm from 'features/pricingManagement/ActivityItemDetailsForm/ActivityItemDetailsForm';
import { CREATE_ACTIVITY_PRICING_STEP_KEYS } from '../createActivityAndPricingConsts';
import { saveStepData } from '../createActivityAndPricingStateSlice';

const ActivityItemDetailsStep = () => {
    const dispatch = useDispatch();
    const activityDetailsFromStore = useSelector(
        state => state.createActivityAndPricingState.steps[CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS]
    );

    const handleSaveActivityDetails = (data) => {
        dispatch(saveStepData({
            stepKey: CREATE_ACTIVITY_PRICING_STEP_KEYS.ACTIVITY_DETAILS,
            data
        }));
    };
    return (
        <ActivityItemDetailsForm
            activityItem={activityDetailsFromStore}
            activityToEdit={activityDetailsFromStore}
            setActivityToEdit={handleSaveActivityDetails}
        />
    );
};

export default ActivityItemDetailsStep;
